import { render, staticRenderFns } from "./m-block-goods-import-result.vue?vue&type=template&id=61c2ac52&scoped=true&lang=pug&"
import script from "./m-block-goods-import-result.vue?vue&type=script&lang=js&"
export * from "./m-block-goods-import-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c2ac52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
